import type {
	PlaceOrModifyOrdersRequest,
	PlaceOrModifyOrdersResponse,
	GetAllOrdersRequest,
	CancelOrdersRequest,
	CancelOrdersResponse,
	TradingAccountSyncRequest
} from '../proto/generated/trading-bridge'
import type { Order } from '../proto/generated/order'
import type { PositionRequest, PositionResponse } from '../proto/generated/position'
import type {
	AuthProviderLoginUrlResponse,
	ForgetPasswordRequest,
	LoginRequest,
	LoginResponse,
	User,
	UserSignUpRequest,
	ValidateThirdPartyTokenRequest
} from '../proto/generated/identity'

export enum BackendProvider {
	TICK2TRADE = 'tick2trade',
	SHOONYA = 'shoonya'
}

export interface BackendConfig {
	provider: BackendProvider
	baseUrl: string
	wsUrl?: string
	apiKey?: string
	headers?: Record<string, string>
}

export interface IBackendAdapter {
	getProvider(): BackendProvider
	getBaseUrl(): string
	getWebSocketUrl(): string

	transformRequest<T = any>(endpoint: string, data: T, method: string): {
		url: string
		data: any
		headers?: Record<string, string>
	}

	transformResponse<T = any>(response: any, endpoint: string): T

	transformError(error: any): any

	placeOrModifyOrder(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse>
	getOrders(request: GetAllOrdersRequest): Promise<Order[]>
	cancelOrder(request: CancelOrdersRequest): Promise<CancelOrdersResponse>
	syncOrders(request: TradingAccountSyncRequest): Promise<Order[]>
	getPositions(request: PositionRequest): Promise<PositionResponse>
	getPlacedOrder(params: any): Promise<Order>

	getLoginUrl(body: any): Promise<AuthProviderLoginUrlResponse>
	loginWithMail(body: LoginRequest): Promise<LoginResponse>
	signUpWithMail(userSignUpRequest: UserSignUpRequest): Promise<LoginResponse>
	sendEmailOtp(email: string): Promise<any>
	forgetPassword(body: ForgetPasswordRequest): Promise<User>
	validateToken(body: ValidateThirdPartyTokenRequest): Promise<LoginResponse>
}
